import React, { useState, useEffect } from "react";
import { Container, Grid, Typography, Link } from "@mui/material";
import "./Footer.css";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import { images } from "../../config/images";
import { customPage, footer } from "../../config/services";
import { useNavigate } from "react-router-dom";
import { slugify } from "../../utils/slugify";
import { Link as RouterLink } from "react-router-dom";

const Footer = ({ headerAPIData }) => {

  const [customPageAPIData, setCustomPageAPIData] = useState([]);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    handleCustomPage();
  }, []);

  const handleCustomPage = async () => {
    const params = {
      type: "footer",
    };

    try {
      const resp = await customPage({ params });
      if (resp.data.code == 200 || resp.data.code == 201) {
        setCustomPageAPIData(resp.data.responseBody);
        localStorage.setItem('customApiData', JSON.stringify(resp.data.responseBody));
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };
  const navigate = useNavigate();
  return (
    <>
      <div>
        <footer className="footer">
          <div className="footer-container common-sec">
            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={3}
                className="footer-section"
              >
                <img
                  src={headerAPIData?.footer?.footer_logo}
                  alt="Anax Lifescience"
                  className="footer-logo"
                  onClick={() => navigate("/")}
                />
                <p className="footer-description">{headerAPIData?.footer?.footer_description}</p>
                <div className="social-icons">
                  <a
                    href={headerAPIData?.footer?.facebook_link || "#"}
                    aria-label="Facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-facebook-f" />
                  </a>
                  <a
                    href={headerAPIData?.footer?.twitter_link || "#"}
                    aria-label="Twitter"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-twitter" />
                  </a>
                  <a
                    href={headerAPIData?.footer?.linkedin_link || "#"}
                    aria-label="LinkedIn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-linkedin-in" />
                  </a>
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={2}
                // sx={{ mt: { xs: 3, sm: 0 } }}
                className="footer-section"
              >
                <h3 className="footer-heading">Quick Link</h3>
                <ul>
                  <li>
                    <Link href="/">Home</Link>
                  </li>
                  <li>
                    <Link href="/aboutus">About Us</Link>
                  </li>
                  <li>
                    <Link href="/gallery">Gallery</Link>
                  </li>
                  <li>
                    <Link href="/blog">Blog</Link>
                  </li>
                  <li>
                    <Link href="/career">Career</Link>
                  </li>
                  <li>
                    <Link href="/contactus">Contact Us</Link>
                  </li>
                  {customPageAPIData?.map((page, index) => (
                    // <li key={index}>
                    //   <Link
                    //     href={page.link}
                    //     target="_blank"
                    //   rel="noopener noreferrer"
                    //   >
                    //     {page.title}
                    //   </Link>
                    // </li>

                    <li key={index}>
                      {page.link ? (
                        // If link exists, use Material-UI Link for external navigation
                        <Link
                          href={page.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          underline="hover"
                        >
                          {page.title}
                        </Link>
                      ) : (
                        // If no link, use Material-UI Link with RouterLink for internal routing
                        <Link
                          component={RouterLink}
                          to={`/${page.slug}`}
                          underline="hover"
                        >
                          {page.title}
                        </Link>
                      )}
                    </li>
                  ))}
                  {/* <li>
                    <Link href="/privacypolicy">
                      {customPageAPIData?.[0]?.title}
                    </Link>
                  </li>

                  <li key={customPageAPIData?.id}>
                    <Link
                      href={customPageAPIData?.[1]?.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {customPageAPIData?.[1]?.title}
                    </Link>
                  </li> */}
                </ul>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={3}
                className="footer-section"
              >
                <h3 className="footer-heading">Product Segment</h3>
                <div className="product-segment-container">
                  {headerAPIData?.product_segment?.map((product) => (
                    <ul key={product?.id}>
                      <li>
                        {/* <Link href={`/${product?.category_id}`}>{product?.title}</Link> */}
                        <Link
                          onClick={() => navigate(`/division/${slugify(product?.category_title)}`, { state: { id: product?.id, navTitle: product?.category_title, title: product?.title, category_id: product?.category_id } })}
                          style={{ cursor: "pointer" }}
                        >
                          {product?.title}
                        </Link>
                      </li>
                    </ul>
                  ))}
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={4}
                className="footer-section"
              >
                <h3 className="footer-heading">Contact Us</h3>
                <ul>
                  <div className="footer-contact">
                    <li>LOCATION:</li>
                    <li>{headerAPIData?.footer.footer_address}</li>
                  </div>
                  <div className="footer-contact">
                    <li>CALL US:</li>
                    <div>
                      <li>
                        <a href={`tel:${headerAPIData?.footer?.footer_phone_1}`} >
                          {headerAPIData?.footer.footer_phone_1}
                        </a>
                      </li>
                      <li>
                        <a href={`tel:${headerAPIData?.footer?.footer_phone_2}`} >
                          {headerAPIData?.footer.footer_phone_2}
                        </a>
                      </li>
                    </div>
                  </div>
                  <div className="footer-contact">
                    <li>EMAIL:</li>
                    <li>
                      <Link href={`mailto:${headerAPIData?.footer.footer_email}`}>
                        {headerAPIData?.footer.footer_email}
                      </Link>
                    </li>
                  </div>
                </ul>
              </Grid>
            </Grid>
            <div className="footer-bottom">
              <span className="footer-copyright">© Copyright {currentYear}. All Rights Reserved.</span>
              <span className="footer-credit">
                Design And Developed by{" "}
                <a href="https://srashtasoft.com/" target="_blank" rel="noopener noreferrer">SrashtaSoft.</a>
              </span>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Footer;
